import React from "react";
import { motion } from "framer-motion";
import styles from "./DownloadAppSection.module.css";

// @author Satyam
const DownloadAppSection = () => {
    return (
        <motion.section className={`${styles.downloadAppSection} bg-white py-16 px-4 sm:px-6 lg:px-10`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between">
                <motion.div className="lg:w-1/2 mb-12 lg:mb-0 text-center lg:text-left" initial={{ x: -100, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.8, ease: "easeOut" }}>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                        <span className="text-[#4267B2]">Prepare Anytime</span>, Anywhere
                    </h2>
                    <p className="text-base sm:text-lg text-gray-700 mb-8">Download the Drishti Learning App today and take your learning with you wherever you go. Empower your preparation with expert guidance.</p>
                    <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                        <motion.a href="https://play.google.com/store/apps/details?id=com.drishti.academy.app&hl=en_IN" target="blank" className="transition-transform hover:scale-105" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                            <img src="/images/Dashboard/getitongoogleplay.png" alt="Get it on Google Play" className="h-12 drop-shadow-md" />
                        </motion.a>
                        <motion.a href="https://apps.apple.com/in/app/drishti-learning-app/id1604411528" target="blank" className="transition-transform hover:scale-105" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                            <img src="/images/Dashboard/Mask group (5).png" alt="Download on the App Store" className="h-12 drop-shadow-md" />
                        </motion.a>
                        <motion.a href="https://dla.drishtiias.com/windows/" className="transition-transform hover:scale-105" target="blank" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                            <img src="https://vault.drishtijudiciary.com/english_file_uploads/1738151746_Group-1321315373-1.png" alt="Get it on Windows" className="h-12 drop-shadow-md" />
                        </motion.a>
                    </div>
                </motion.div>

                <motion.div className="lg:w-1/2 relative flex justify-center items-center" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.8, ease: "easeOut" }}>
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-200 to-indigo-300 rounded-full filter blur-3xl opacity-30 animate-pulse"></div>
                    <div className="relative z-10 flex items-center space-x-4 sm:space-x-6">
                        <motion.img
                            src="/images/Dashboard/3_Device_Mashup.png"
                            alt="Drishti App Screenshot 1"
                            className="w-120 sm:w-120 lg:w-120 h-auto transform z-20 drop-shadow-xl"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        />
                    </div>
                </motion.div>
            </div>
        </motion.section>
    );
};

export default DownloadAppSection;
